<template>
  <q-btn
    round
    dense
    flat
    icon="mdi-help-circle-outline"
    :size="dense ? '10px' : undefined"
    :padding="dense ? 'none' : undefined"
    @click="hasMenu ? undefined : openHelpCenter()"
  >
    <q-tooltip v-if="!hasMenu">
      Help Center
    </q-tooltip>
    <q-menu v-if="hasMenu" auto-close>
      <q-list dense style="min-width: 200px;">
        <q-item
          clickable
          @click="openHelpCenter"
        >
          <q-item-section avatar>
            <q-icon name="mdi-help-circle-outline" size="20px" />
          </q-item-section>
          <q-item-section>Help Center</q-item-section>
        </q-item>
        <q-item
          v-if="onboardingEvent"
          clickable
          @click="$bus.emit(onboardingEvent)"
        >
          <q-item-section avatar>
            <q-icon name="mdi-school-outline" size="20px" />
          </q-item-section>
          <q-item-section>Replay Walkthrough</q-item-section>
        </q-item>
        <template v-if="tours.length > 0">
          <q-separator />
          <q-item-label
            header
            class="text-caption text-grey-7 q-pb-none"
          >
            Guided Tours
          </q-item-label>
          <q-item
            v-for="tour in tours"
            :key="tour.event"
            :clickable="!tour.disable"
            :disable="tour.disable"
            @click="!tour.disable ? $bus.emit(tour.event) : null"
          >
            <q-item-section avatar>
              <q-icon :name="tour.icon || 'mdi-school-outline'" size="20px" />
            </q-item-section>
            <q-item-section>
              {{ tour.label }}
              <q-item-label v-if="tour.disable" caption>
                Coming soon
              </q-item-label>
            </q-item-section>
            <q-item-section
              v-if="completedTours.includes(tour.event)"
              side
            >
              <q-icon
                name="mdi-check"
                color="green"
                size="16px"
              />
            </q-item-section>
          </q-item>
        </template>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>
export default {
  props: {
    filter: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    onboardingEvent: {
      type: String,
      default: null
    },
    tours: {
      type: Array,
      default: () => []
    },
    completedTours: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasMenu () {
      return !!this.onboardingEvent || this.tours.length > 0
    }
  },
  methods: {
    openHelpCenter () {
      if (!this.filter) {
        this.$bus.emit('help:toggle', true)
      }
      else {
        this.$bus.emit('help:search', this.filter)
      }
    }
  }
}
</script>
